import _axios from '../../apiClient'

export function getCatalogosActivos(payload) {
  return _axios
    .get(
      `/api/Catalogo/GetCatalogosActivos`,
      {
        params: { idInstalacion: payload },
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getCatalogoSeleccionado(payload) {
  return _axios
    .get(
      `/api/Catalogo/GetCatalagoSeleccionado`,
      {
        params: !payload.idUsuario
          ? { ...payload, idUsuario: 'aaaa-bbbb-cccc-dddd-cccc' }
          : payload,
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getIdCatalogoPublicadoActual() {
  return _axios
    .get(
      `/api/Catalogo/GetIdCatalogoPublicado`,
      {
        params: {},
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getRubrosSubrubros(payload) {
  return _axios
    .get(
      `/api/Catalogo/GetRubrosSubrubros`,
      {
        params: payload,
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getSubFiltrosArticulos(payload) {
  return _axios
    .get(
      `/api/Catalogo/GetCatalagoSeleccionadoFiltros`,
      {
        params: payload,
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

function generarNumeroAleatorio() {
  let array = new Uint32Array(1)
  window.crypto.getRandomValues(array)
  return 100000 + (array[0] % 900000)
}

export function postBotonArrepentimiento(payload) {
  const numeroPedido = generarNumeroAleatorio()

  const mensaje = `Hola ${payload.nombre}, Usted ha rellenado el formulario de arrepentimiento de compra.
  Su número de reclamo es ${numeroPedido}. 
  DNI: ${payload.dni}.
  Teléfono: ${payload.telefono}.
  Motivo de arrepentimiento: ${payload.descripcion}. 
  A la brevedad será contactado por un representante.
  Muchas gracias.`

  return _axios
    .post(
      '/api/EmailArrepentimiento/SendArrepentimientoEmail',
      {
        nombre: payload.nombre,
        direccion: payload.email,
        descripcion: payload.descripcion,
        DNI: payload.dni,
        numeroPedido: numeroPedido,
        body: mensaje,
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw error.response.data
    })
}
